/**
 * Entities types
 *
 * @type {object}
 */
export const entities = {
  product: 'product',
  category: 'category',
  article: 'article',
  page: 'page'
};
/**
 * Entities types titles
 *
 * @type {object}
 */

export const entitiesTitles = {
  [entities.product]: 'Продукт',
  [entities.category]: 'Категория',
  [entities.article]: 'Статья',
  [entities.page]: 'Страница'
};